import React from 'react';
import { ChevronLeft, ChevronRight, Grid3X3, Star } from 'lucide-react';
import { Button } from '../ui/button';
import { QUESTION_RESPONSE_STATUS } from '../../constants';

const BottomNavigation = ({
  currentQuestionIndex,
  totalQuestions,
  questionLabel,
  onPrevious,
  onNext,
  onOpenNavigation,
  studentResponse,
  rcContext,
  isFirstQuestion,
  isLastQuestion,
  isDisabled = false
}) => {
  const getStatusCounts = () => {
    let answered = 0;
    let bookmarked = 0;
    let skipped = 0;

    studentResponse?.forEach((response) => {
      if (response.status === QUESTION_RESPONSE_STATUS.ANSWERED) answered++;
      if (response.status === QUESTION_RESPONSE_STATUS.SKIPPED) skipped++;
      if (response.isBookmarked) bookmarked++;
    });

    return { answered, bookmarked, skipped };
  };

  const { answered, bookmarked, skipped } = getStatusCounts();

  return (
    <div className="border-t border-border/50 bg-card px-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] pt-4">
      <div className="mb-3 flex items-center justify-center gap-4 text-xs">
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-green-500" />
          <span className="text-muted-foreground">{answered} Answered</span>
        </div>
        <div className="flex items-center gap-1">
          <Star className="h-3 w-3 fill-current text-yellow-500" />
          <span className="text-muted-foreground">{bookmarked} Bookmarked</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="h-3 w-3 rounded-full bg-orange-500" />
          <span className="text-muted-foreground">{skipped} Skipped</span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onPrevious}
          disabled={isFirstQuestion || isDisabled}
          className="border-primary/20 px-3 hover:border-primary/50"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>

        <Button
          type="button"
          variant="outline"
          onClick={onOpenNavigation}
          disabled={isDisabled}
          className="flex h-auto flex-1 flex-col items-center justify-center gap-0.5 border-primary/20 py-2 hover:border-primary/50 hover:bg-primary/5"
        >
          <div className="flex items-center gap-2">
            <Grid3X3 className="h-4 w-4" />
            <span>
              {questionLabel
                ? `Question ${questionLabel} · ${currentQuestionIndex + 1} of ${totalQuestions}`
                : `Question ${currentQuestionIndex + 1} of ${totalQuestions}`}
            </span>
          </div>
          {rcContext && (
            <span className="text-xs text-muted-foreground">
              Part {rcContext.subIndex + 1} of {rcContext.totalSub}
            </span>
          )}
        </Button>

        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onNext}
          disabled={isLastQuestion || isDisabled}
          className="border-primary/20 px-3 hover:border-primary/50"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default BottomNavigation;
